<template>
  <div :class="certification ? 'login_wrap clear_mtop' : 'login_wrap'">
    <div :class="certification ? 'autos findpwd_form_box' : 'findpwd_form_box'">
      <div class="tit_box">
        <h1>重置密码</h1>
        <div>
          <span>手机短信方式</span>
        </div>
      </div>
      <el-form
        ref="resetForm"
        :model="resetForm"
        :rules="rules"
        class="demo-ruleForm login_register_form"
        @submit.native.prevent
        style="margin-top: 24px"
      >
        <el-form-item prop="phone" :error="errorUserMsg">
          <el-input placeholder="请输入手机号" v-model="resetForm.phone">
            <template slot="prepend">+86</template>
            <template slot="append">
              <span @click="handleVerification">{{ content }}</span>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="phoneCode" :error="errorValidationrMsg">
          <el-input
            v-model="resetForm.phoneCode"
            placeholder="短信6位验证码"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="newPassword">
          <el-form-item prop="newPassword">
            <el-input
              v-model="resetForm.newPassword"
              type="password"
              placeholder="新账户密码"
              @keyup.enter.native="submitForm('resetForm')"
              clearable
            ></el-input>
          </el-form-item>
        </el-form-item>

        <el-form-item style="text-align: right; margin-bottom: 17px">
          <a @click="goback">返回登录页</a>
        </el-form-item>
        <el-form-item class="cen" style="margin-bottom: 0">
          <el-button
            type="primary"
            class="next_btn"
            @click="submitForm('resetForm')"
            style="width: 100%"
            >重置密码</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <DialogVerificationCode
      v-if="dialogVisible"
      @handleClose="handleClose"
      @countDown="countDown"
      :dialogVisible="dialogVisible"
      :phone="this.resetForm.phone"
    />
  </div>
</template>

<script>
import DialogVerificationCode from '@/components/Dialog/VerificationCode/index.vue';
import { validateResetPasswordCode } from '@/utils/validate';

export default {
  name: 'RegisterednewPassword',
  components: {
    DialogVerificationCode
  },
  data() {
    const validateMobilePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号码'));
      } else {
        if (value !== '') {
          var reg = /^1[3456789]\d{9}$/;
          if (!reg.test(value)) {
            callback(new Error('请输入有效的手机号码'));
          }
        }
        callback();
      }
    };

    return {
      certification: window.location.href.indexOf('certification') > -1,
      totalTime: 60,
      errorUserMsg: null,
      errorValidationrMsg: null,
      dialogVisible: null,
      disabled: true,
      content: '发送验证码',
      resetForm: {
        phone: '',
        phoneCode: '',
        newPassword: ''
      },
      rules: {
        phone: [
          {
            required: true,
            trigger: 'blur',
            validator: validateMobilePhone
          }
        ],
        phoneCode: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          },
          {
            min: 6,
            max: 6,
            message: '请输入正确验证码',
            trigger: 'blur'
          }
        ],
        newPassword: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          },
          {
            min: 6,
            max: 255,
            message: '密码长度在6-255位',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  mounted() {},
  methods: {
    countDown() {
      if (!this.disabled) return; // 改动的是这两行代码
      this.disabled = false;
      this.dialogVisible = false;
      this.content = this.totalTime + 's';
      const _th = this;
      const clock = window.setInterval(() => {
        _th.totalTime--;
        _th.content = _th.totalTime + 's';

        if (_th.totalTime < 0) {
          window.clearInterval(clock);
          _th.content = '发送验证码';
          _th.totalTime = 60;
          _th.disabled = true; // 这里重新开启
        }
      }, 1000);
    },
    detection(value, type, isPhone) {
      this.$refs.resetForm.validateField(value, (moneyError) => {
        if (!moneyError) {
          this.check(this.resetForm[value], type, isPhone);
        }
      });
    },
    handleVerification() {
      this.dialogVisible = null;
      this.errorUserMsg = null;
      this.$refs.resetForm.validateField('phone', (moneyError) => {
        if (!moneyError) {
          if (!this.disabled) return;
          this.$store
            .dispatch('checkPhone', {
              phone: this.resetForm.phone
            })
            .then(() => {
              this.dialogVisible = true;
            })
            .catch((err) => {
              if (err && err.code) {
                if (err.code === 3001) {
                  this.errorUserMsg = '账户不存在';
                }
                if (err.code === 3004) {
                  this.dialogVisible = true;
                }
              }
            });
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },

    goback() {
      this.$router.go(-1);
    },
    submitForm(formName) {
      this.errorUserMsg = null;
      this.errorValidationrMsg = null;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store
            .dispatch('ModifyPassword', {
              phoneNbr: this.resetForm.phone,
              phoneCode: this.resetForm.phoneCode,
              newPassword: this.resetForm.newPassword
            })
            .then((res) => {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              this.$router.push({
                name: this.certification ? 'certificationLogin' : 'login'
              });
            })
            .catch((err) => {
              if (err && err.code) {
                validateResetPasswordCode(err.code, (msg, errname) => {
                  this.errorUserMsg =
                    (errname === 'errorUserMsg' && msg) || null;
                  this.errorValidationrMsg =
                    (errname === 'errorValidationrMsg' && msg) || null;
                });
              }
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.autos {
  margin: 0 auto !important;
}
.login_wrap {
  display: flex;
  justify-content: center;
  .findpwd_form_box {
    width: 480px;
    background: #ffffff;
    // min-height: 400px;
    box-sizing: border-box;
    padding: 36px;
    .tit_box {
      display: flex;
      justify-content: space-between;
      h1 {
        font-size: 18px;
      }
      span {
        opacity: 0.8;
      }
      >div{
        display: flex;
        align-items: center;
      }
    }
    .steps_box {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      div {
        background-color: #fff;
        color: #4d4d4f;
        border-radius: 4px;
        padding: 10px 18px;
      }
      .active_step {
        background-color: #1890ff;
      }
    }
    .tips {
      margin-top: 10px;
      opacity: 0.6;
    }
    .title {
      font-size: 16px;
      margin: 20px 0 10px;
    }
    .agree_txt {
      opacity: 0.8;
    }
    .el-form-item__label {
      font-size: 16px;
    }
  }
}
.clear_mtop {
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/resetPassword/components/ResetPassword/index.vue